import { NpsCocoImageData } from "./nps-coco-image.data";
import { INpsCocoImageData } from "./nps-coco-image.types";
export const useNpsCocoImage = (rating: string | null): INpsCocoImageData => {
  if (rating === null || rating === "") {
    return NpsCocoImageData.initialData;
  }
  if (Number(rating) < 4) {
    return NpsCocoImageData.negativeData;
  }
  if (Number(rating) < 7) {
    return NpsCocoImageData.semiNegative;
  }
  if (Number(rating) < 9) {
    return NpsCocoImageData.neutralData;
  }
  return NpsCocoImageData.promoterData;
};
